import React, { useState, useEffect, useRef } from "react";
import LoadingModal from "./components/LoadingModal.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import Login from "./pages/Login.js";

const LanguageTool = () => {
	const [environment, setEnvironment] = useState("sandbox1");
	const [runType, setRunType] = useState("ID");
	const [userDate, setUserDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [creationDate, setcreationDate] = useState("");
	const [filterModified, setFilterModified] = useState("no");
	const [ids, setIds] = useState("");
	const [uploadedFile, setUploadedFile] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loggedIn, setLoggedIn] = useState(true);
	const [loginError, setLoginError] = useState("");
	const [loginInfo, setLoginInfo] = useState({
		username: "",
		password: "",
		partyID: "",
	});
	const [statusLog, setStatusLog] = useState([]);
	const [serverLog, setServerLog] = useState([]);
	const [mismatchLog, setMismatchLog] = useState([]);
	const [inputType, setInputType] = useState("text");
	const [pageNumber, setPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(240);
	const [timeOutEnabled, setTimeOutEnabled] = useState(false);
	const [showReconnectPopup, setShowReconnectPopup] = useState(false);
	const [completed, setCompleted] = useState(false);
	const [pollingActive, setPollingActive] = useState(false);
	const pollingIntervalRef = useRef(null);
	const API_URL =
		process.env.NODE_ENV === "production"
			? `${process.env.REACT_APP_DEPLOY_DOMAIN}/api`
			: "http://localhost:3001";

	const startPollingLogs = () => {
		if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
		function fetchLogs() {
			fetch(`${API_URL}/api/logs`)
				.then(async (res) => {
					if (!res.ok) {
						const text = await res.text();
						throw new Error(`Error ${res.status}: ${text}`);
					}
					return res.json();
				})
				.then((data) => {
					setStatusLog(data.statusList);
					setMismatchLog(data.mismatchList);
					setServerLog(data.serverErrorList);
					if (data.completed === true) {
						setCompleted(true);
						setLoading(false);
						setPollingActive(false); // Stop polling
					}
				})
				.catch((err) => {
					console.error("Polling error:", err);
				});
		}
		fetchLogs();
		pollingIntervalRef.current = setInterval(fetchLogs, 5000);
	};

	useEffect(() => {
		if (pollingActive) {
			setLoading(true);
			startPollingLogs();
		}
		return () => {
			if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
		};
	}, [pollingActive]);

	const handleEnvironmentChange = (e) => {
		setEnvironment(e.target.value);
	};

	const handleRunTypeChange = (e) => {
		setRunType(e.target.value);
	};

	const handleFilterModifiedChange = (e) => {
		setFilterModified(e.target.value);
	};

	const handleIdsChange = (e) => {
		setIds(e.target.value);
	};

	const handleFileUpload = (e) => {
		const file = e.target.files[0];
		if (file) {
			setUploadedFile(file); // Store the file object in the state
		}
	};

	const toggleInputType = () => {
		setInputType((prevType) => (prevType === "text" ? "file" : "text"));
		setIds(""); // Reset the ids state
		setUploadedFile(null); // Reset the uploaded file state
	};

	const downloadLogFile = (logData, logType) => {
		const blob = new Blob([logData.join("\n")], { type: "text/plain" });
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		if (runType === "ID") {
			a.download = `${logType}-log.txt`;
		} else {
			a.download = `${logType}-log-${userDate}-${endDate}.txt`;
		}
		a.click();
		URL.revokeObjectURL(url);
	};

	const generateXmlData = () => {
		if (runType === "ID") {
			if (inputType === "file") {
				return uploadedFile;
			} else {
				return ids.split("\n");
			}
		} else {
			let xmlContent = `<?xml version="1.0" encoding="UTF-8"?>
            <Request xmlns="http://www.eidr.org/schema"
            xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
                <Operation>
                    <Query>
                        <Expression>(/ProvenanceMetadata/CreationDate &gt;= ${userDate}) AND (/ProvenanceMetadata/CreationDate &lt;= ${endDate}) AND (/FullMetadata/BaseObjectData/Status valid)`;

			if (filterModified === "yes" || environment === "registry1") {
				xmlContent += ` AND NOT ((/ProvenanceMetadata/LastModifiedBy 10.5238/language-api))`;
			}

			xmlContent += `</Expression>
                        <PageNumber>${pageNumber}</PageNumber>
                        <PageSize>${pageSize}</PageSize>
                    </Query>
                </Operation>
            </Request>`;

			return xmlContent;
		}
	};
	const handleSubmit = () => {
		setLoading(true);
		setShowReconnectPopup(false);

		const query = `${API_URL}/api/resolvelanguage/${environment}`;
		const formData = new FormData();
		formData.append("username", loginInfo.username.trim());
		formData.append("password", loginInfo.password.trim());
		formData.append("partyID", loginInfo.partyID.trim());
		formData.append("runType", runType);
		formData.append("inputType", inputType);
		formData.append("userDate", userDate);
		formData.append("endDate", endDate);
		formData.append("creationDate", creationDate);
		formData.append("filterModified", filterModified);
		formData.append("environment", environment);
		formData.append("timeOutEnabled", timeOutEnabled);

		if (runType === "ID" && inputType === "file" && uploadedFile) {
			formData.append("idsFile", uploadedFile);
		} else if (runType === "ID" && inputType === "text") {
			formData.append("xml_data", ids);
		} else if (runType === "Date") {
			formData.append("xml_data", generateXmlData());
		}

		fetch(query, {
			method: "POST",
			body: formData,
		})
			.then((response) => {
				if (!response.ok) {
					if (response.status === 401) {
						setLoginError("Invalid credentials provided.");
					} else {
						setLoginError(`Error: Backend returned status ${response.status}`);
					}
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				setStatusLog(data.statusList);
				setServerLog(data.serverErrorList);
				setMismatchLog(data.mismatchList);
			})
			.catch((error) => {
				console.error("Error during submission:", error);
				setShowReconnectPopup(true);
				setLoginError("An error occurred while processing your request.");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const handleReconnect = () => {
		setShowReconnectPopup(false);
		setLoginError("");
		setPollingActive(true); // Resume polling only
	};
	return (
		<div className='bg-gradient-to-r from-gray-400 to-green-700 min-h-screen w-full py-6 flex flex-col justify-center sm:py-12 items-center'>
			{showReconnectPopup && (
				<div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
					<div className='bg-white p-6 rounded shadow-lg flex flex-col items-center'>
						<p className='mb-4 text-lg font-semibold text-red-600'>
							Connection lost or interrupted. Please try again.
						</p>
						<button
							onClick={handleReconnect}
							className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700'
						>
							Reconnect
						</button>
					</div>
				</div>
			)}
			{completed && (
				<div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
					<div className='bg-white p-6 rounded shadow-lg flex flex-col items-center'>
						<p className='mb-4 text-lg font-semibold text-green-600'>
							All records successfully processed!
						</p>
						<button
							onClick={() => setCompleted(false)}
							className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700'
						>
							Close
						</button>
					</div>
				</div>
			)}
			{loggedIn ? (
				<div className='flex flex-col items-center justify-center'>
					<h1 className='text-4xl font-bold text-center mb-4'>Language Tool</h1>
					<div className='flex flex-col w-full max-w-sm'>
						<input
							type='text'
							name='username'
							placeholder='Username'
							value={loginInfo.username}
							onChange={(e) =>
								setLoginInfo({ ...loginInfo, username: e.target.value })
							}
							className='mb-4 w-full'
						/>

						<input
							type='password'
							name='password'
							placeholder='Password'
							value={loginInfo.password}
							onChange={(e) =>
								setLoginInfo({ ...loginInfo, password: e.target.value })
							}
							className='mb-4 w-full'
						/>

						<input
							type='text'
							name='partyID'
							placeholder='Party ID'
							value={loginInfo.partyID}
							onChange={(e) =>
								setLoginInfo({ ...loginInfo, partyID: e.target.value })
							}
							className='mb-4 w-full'
						/>
						{loginError && (
							<div className='mt-2 w-full flex items-center'>
								<FontAwesomeIcon
									icon={faWarning}
									className='text-red-500 mr-2'
								/>
								<span className='text-red-500'>{loginError}</span>
							</div>
						)}
					</div>
					<div className='flex flex-col w-full max-w-sm pr-0 mt-4 ml-2'>
						<label>Environment</label>
						<select
							value={environment}
							onChange={handleEnvironmentChange}
							className='text-black bg-white rounded-lg shadow-lg transition duration-500 w-full'
						>
							<option value='sandbox1'>Sandbox1</option>
							<option value='sandbox2'>Sandbox2</option>
							<option value='registry1'>Production</option>
						</select>
					</div>
					<div className='flex flex-col w-full max-w-sm'>
						<label>Run ID or Modification Date?</label>
						<select value={runType} onChange={handleRunTypeChange}>
							<option value='ID'>ID</option>
							<option value='Date'>Date</option>
						</select>
					</div>
					{runType === "ID" ? (
						<div className='flex flex-col w-full max-w-sm'>
							<button
								onClick={toggleInputType}
								className='mb-4 p-2 bg-blue-700 text-white rounded'
							>
								{inputType === "text"
									? "Switch to File Upload"
									: "Switch to Text Input"}
							</button>
							{inputType === "text" ? (
								<>
									<label>Enter IDs (one per line):</label>
									<textarea
										value={ids}
										onChange={handleIdsChange}
										rows='10'
										cols='50'
										className='mb-4 p-2 border rounded'
									/>
								</>
							) : (
								<div className='flex items-center bg-white py-2 shadow-md rounded-lg mt-5 w-full max-w-lg'>
									<input
										type='file'
										accept='.txt'
										onChange={handleFileUpload}
										className='file:mr-4 file:py-2 file:px-4 file:rounded-full file:border file:border-white file:text-sm file:font-semibold file:text-black-700 hover:file:bg-blue-100 hover:file:cursor-pointer'
									/>
								</div>
							)}
						</div>
					) : (
						<div className='flex flex-col w-full max-w-sm'>
							<label>Enter the start date (YYYY-MM-DD):</label>
							<input
								type='text'
								placeholder='YYYY-MM-DD'
								value={userDate}
								onChange={(e) => setUserDate(e.target.value)}
							/>
							<label>Enter the end date (YYYY-MM-DD):</label>
							<input
								type='text'
								placeholder='YYYY-MM-DD'
								value={endDate}
								onChange={(e) => setEndDate(e.target.value)}
							/>
							<label>Do you want to filter out modified records?</label>
							<select
								value={filterModified}
								onChange={handleFilterModifiedChange}
							>
								<option value='yes'>Yes</option>
								<option value='no'>No</option>
							</select>
							{filterModified === "yes" && (
								<div>
									<label>Enter the creation date (YYYY-MM-DD):</label>
									<input
										type='text'
										placeholder='YYYY-MM-DD'
										value={creationDate}
										onChange={(e) => setcreationDate(e.target.value)}
									/>
								</div>
							)}
							<div className='flex'>
								<div className='flex flex-col mr-4'>
									{" "}
									<label>Enter the page number:</label>
									<input
										type='number'
										value={pageNumber}
										onChange={(e) => setPageNumber(e.target.value)}
									/>
								</div>
								<div className='flex flex-col mr-4'>
									{" "}
									<label>Page Size(240 limit):</label>
									<input
										type='number'
										value={pageSize}
										onChange={(e) => setPageSize(e.target.value)}
									/>
								</div>
							</div>
						</div>
					)}
					<div className='flex items-center mt-4'>
						<div className='mt-4 flex w-50 p-2 bg-green-700 text-white mr-3'>
							Enable Timeout
						</div>
						<label className='mt-4 flex w-50 items-center cursor-pointer'>
							<input
								type='checkbox'
								checked={timeOutEnabled}
								onChange={(e) => handleTimeOutEnabled(e.target.checked)}
								className='sr-only peer'
							/>
							<div className='w-14 h-8 bg-gray-300 rounded-full peer-checked:bg-green-500 transition-all duration-300 relative'>
								<div
									className={`absolute left-1 top-1 w-6 h-6 bg-white rounded-full shadow-md transform transition-all duration-300 ${
										timeOutEnabled ? "translate-x-6" : ""
									}`}
								/>
							</div>
						</label>
					</div>

					<button
						onClick={handleSubmit}
						disabled={loading}
						className='grow w-full text-white bg-black rounded-lg shadow-lg p-2 mt-4 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110'
					>
						{loading ? "Loading..." : "Submit"}
					</button>

					{loading && <LoadingModal />}

					{!loading && (
						<table className='table-auto mt-4'>
							<thead>
								<tr>
									<th className='px-4 py-2'>Status Logs</th>
									<th className='px-4 py-2'>Mismatch Logs</th>
									<th className='px-4 py-2'>Server Error Logs</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className='border px-4 py-2'>
										{statusLog && statusLog.length > 0 && (
											<button
												onClick={() => downloadLogFile(statusLog, "status")}
												className='bg-blue-500 text-white px-4 py-2 rounded'
											>
												Download Status Logs
											</button>
										)}
									</td>
									<td className='border px-4 py-2'>
										{mismatchLog && mismatchLog.length > 0 && (
											<button
												onClick={() => downloadLogFile(mismatchLog, "mismatch")}
												className='bg-blue-500 text-white px-4 py-2 rounded'
											>
												Download Mismatch Logs
											</button>
										)}
									</td>
									<td className='border px-4 py-2'>
										{serverLog && serverLog.length > 0 && (
											<button
												onClick={() =>
													downloadLogFile(serverLog, "serverError")
												}
												className='bg-blue-500 text-white px-4 py-2 rounded'
											>
												Download Server Error Logs
											</button>
										)}
									</td>
								</tr>
							</tbody>
						</table>
					)}
				</div>
			) : (
				<div className='flex flex-col items-center justify-center'>
					<Login />
					{loginError && (
						<p>There is problem with logging in, please try again</p>
					)}
					{loading && <LoadingModal />}
				</div>
			)}
		</div>
	);
};

export default LanguageTool;
